import { render, staticRenderFns } from "./ImgZoom.vue?vue&type=template&id=37fc27b5&scoped=true&"
import script from "./ImgZoom.vue?vue&type=script&lang=js&"
export * from "./ImgZoom.vue?vue&type=script&lang=js&"
import style0 from "./ImgZoom.vue?vue&type=style&index=0&id=37fc27b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fc27b5",
  null
  
)

export default component.exports